
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from "../Image/logo.png"
function Header() {
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(false);
    const [openMenu1, setOpenMenu1] = useState(false);
    const [toggelbar, setToggelbar] = useState(false);

    const clickCompany = () => {
        setOpenMenu(!openMenu);
    };
    const clickCompany1 = () => {
        setOpenMenu1(!openMenu1);
    };
    const Toggelmenu = () => {
        setToggelbar(!toggelbar);
    };
    return (
        <>
            <header
                className="main-header navfix menu-white"
                style={{
                    backgroundColor: "white",
                    position: "sticky",
                    top: 0,
                    zIndex: 1030,
                    width: "100%",
                }}
            >
                <div className="container-fluid m-pad">
                    <div className="menu-header">
                        <div className="dsk-logo">
                            <Link to="/">
                                <img src={logo} alt="Logo" className="mega-white-logo" style={{ width: "200px" }} />
                            </Link>
                            <Link to="/">
                                <img src={logo} alt="Logo" className="mega-darks-logo" style={{ width: "200px" }} />
                            </Link>
                        </div>
                        <div className="custom-nav" role="navigation">
                            <ul className="nav-list">
                                <li className="sbmenu">
                                    <Link to="/" className="menu-links" style={{ color: "black" }}>Home</Link>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <a href="#" className="menu-links" style={{ color: "black" }}>Company</a>
                                    <div className="nx-dropdown menu-dorpdown">
                                        <div className="sub-menu-section">
                                            <div className="sub-menu-center-block">
                                                <div className="sub-menu-column smfull">
                                                    <ul>
                                                        <li>
                                                            <Link to="/aboutus">About Us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/whyus">Why Us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/mission">Mission & Vision</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <a href="#" className="menu-links" style={{ color: "black" }}>Service</a>
                                    <div className="nx-dropdown menu-dorpdown">
                                        <div className="sub-menu-section">
                                            <div className="sub-menu-center-block">
                                                <div className="sub-menu-column smfull">
                                                    <ul>
                                                        <li>
                                                            <Link to="/webapplication">Web Application</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/mobileapplication">Mobile Application</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/digitalmarketing">Digital Marketing</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/itsecurity">IT Security</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <Link to="/product" className="menu-links" style={{ color: "black" }}>Product</Link>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <Link to="/career" className="menu-links" style={{ color: "black" }}>Careers</Link>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <Link to="/blog" className="menu-links" style={{ color: "black" }}>Blog</Link>
                                </li>
                                <li className="sbmenu rpdropdown">
                                    <Link to="/contactus" className="menu-links" style={{ color: "black" }}>Contact Us</Link>
                                </li>
                            </ul>
                            <ul className="nav-list right-end-btn">
                                <li className="hidemobile">
                                    <a href="tel:+91 8826302378" className="btn-round- btn-br bg-btn2">
                                        <i className="fas fa-phone-alt"></i>
                                    </a>
                                </li>
                                <li className="hidemobile"   ><Link to="/contactus" className="btn-br bg-btn3 btshad-b2 lnk" >Request A Quote <span className="circle"></span></Link> </li>
                                <li className="navm- hidedesktop" onClick={Toggelmenu}> {toggelbar === true ? <i className="fa fa-times" aria-hidden="true" style={{ fontSize: "35px" }} /> : <i className="fa fa-bars " aria-hidden="true" style={{ fontSize: "35px" }} />}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
            <div >
                <div style={{ width: "320px", visibility: toggelbar ? "visible" : "hidden" }} className={`offcanvas offcanvas-start bg-white d-lg-none ${toggelbar ? 'show' : ''}`} data-bs-scroll="true" tabIndex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">
                            <Link to="/" onClick={() => setToggelbar(false)}>
                                <img src={logo} alt="Logo" style={{ width: "150px" }} />
                            </Link>
                        </h5>
                        <button type="button" className="btn-close text-reset" onClick={() => setToggelbar(false)} aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body mt-4">
                        <div className="list-group">
                            <Link to="/" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ${location.pathname === '/' ? 'active bg-dark text-white' : ''}`} aria-current="true">
                                Home
                            </Link>
                            
                            {/* Company Section */}
                            <div className="list-group-item list-group-item-light fw-bold bg-light text-dark" style={{ pointerEvents: 'none' }}>Company</div>
                            <Link to="/aboutus" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/aboutus' ? 'active bg-dark text-white' : ''}`}>About Us</Link>
                            <Link to="/whyus" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/whyus' ? 'active bg-dark text-white' : ''}`}>Why Us</Link>
                            <Link to="/mission" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/mission' ? 'active bg-dark text-white' : ''}`}>Mission & Vision</Link>
                            <Link to="/ourteam" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/ourteam' ? 'active bg-dark text-white' : ''}`}>Our Team</Link>

                            {/* Service Section */}
                            <div className="list-group-item list-group-item-light fw-bold bg-light text-dark" style={{ pointerEvents: 'none' }}>Services</div>
                            <Link to="/webapplication" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/webapplication' ? 'active bg-dark text-white' : ''}`}>Web Application</Link>
                            <Link to="/mobileapplication" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/mobileapplication' ? 'active bg-dark text-white' : ''}`}>Mobile Application</Link>
                            <Link to="/digitalmarketing" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/digitalmarketing' ? 'active bg-dark text-white' : ''}`}>Digital Marketing</Link>
                            <Link to="/itsecurity" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/itsecurity' ? 'active bg-dark text-white' : ''}`}>IT Security</Link>

                            {/* Main Links */}
                            <div className="list-group-item list-group-item-light fw-bold bg-light text-dark" style={{ pointerEvents: 'none' }}>Main Pages</div>
                            <Link to="/product" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/product' ? 'active bg-dark text-white' : ''}`}>Product</Link>
                            <Link to="/career" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/career' ? 'active bg-dark text-white' : ''}`}>Careers</Link>
                            <Link to="/blog" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/blog' ? 'active bg-dark text-white' : ''}`}>Blogs</Link>
                            <Link to="/contactus" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/contactus' ? 'active bg-dark text-white' : ''}`}>Contact Us</Link>
                            <Link to="/contactus" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/contactus' ? 'active bg-dark text-white' : ''}`}>Request A Quote</Link>

                            {/* Policies & Support Section */}
                            <div className="list-group-item list-group-item-light fw-bold bg-light text-dark" style={{ pointerEvents: 'none' }}>Resources</div>
                            <Link to="/Faq" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/Faq' ? 'active bg-dark text-white' : ''}`}>Customer's FAQ</Link>
                            <Link to="/Privacypolicy" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/Privacypolicy' ? 'active bg-dark text-white' : ''}`}>Privacy Policy</Link>
                            <Link to="/Termsconditions" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/Termsconditions' ? 'active bg-dark text-white' : ''}`}>Terms & Conditions</Link>
                            <Link to="/Refundpolicy" onClick={() => setToggelbar(false)} className={`list-group-item list-group-item-action ps-4 ${location.pathname === '/Refundpolicy' ? 'active bg-dark text-white' : ''}`}>Refund Policy</Link>
                        </div>
                    </div>
                </div>
            </div>
            {toggelbar && (
                <div 
                    className="offcanvas-backdrop fade show" 
                    onClick={() => setToggelbar(false)}
                    style={{ zIndex: 1040 }}
                ></div>
            )}
        </>
    )
}

export default Header